const actionTypes = {
  status: 'status', //on/off button
  budget: 'budget',
  schedule_date: 'schedule_date', //edit the schedule day
  schedule_time: 'schedule_time', //edit the schedule hour and min (some channel cannot edit the hour so it should be block)
  keyword_bid: 'keywordBid',
};

const disableReasons = {
  INTERNAL_ACCOUNT: 'INTERNAL_ACCOUNT', //account created by adreil system cannot be updateable throught the dashboard
  CHANNEL_NOT_AVAILABLE: 'CHANNEL_NOT_AVAILABLE', //some channels are not editable
  AD_ACCOUNT_BLOCKED: 'AD_ACCOUNT_BLOCKED', //blocked account cannot be editable
  LVL_NOT_AVAILABLE: 'LVL_NOT_AVAILABLE', //action is not possible for this lvl
  ELEMENT_DELETED: 'ELEMENT_DELETED',
  NEEDED_VALUE_MISSING: 'NEEDED_VALUE_MISSING', // the element doesn't have the needed value to fill the form.
  UPLOADED_FILES: 'UPLOADED_FILES', // if the data source is file, we can't update the value.
};
const NOT_AVAILIBLE_CHANNEL = ['google_video'];

/*
****config object****
neededKeys : is a list of needed key, it can check a deep element if you give a subOject.
it's recurssive until it find boolen value. the check between 2 keys is OR logic.
*/
const possibleActions = {
  [actionTypes.status]: {
    availableChannels: {
      campaign: [
        'facebook',
        'instagram',
        'google',
        'google_display',
        'google_search',
        'google_universal_app',
        'linkedin',
        'naver',
        'kakao',
        'microsoft',
        'snapchat',
        'apple',
        'twitter',
        // 'tiktok', not implemented https://adriel-chat.slack.com/archives/C02MJ2F5DJQ/p1736233240690719?thread_ts=1734504629.398309&cid=C02MJ2F5DJQ
        'amazon',
      ],
      adSet: [
        'facebook',
        'instagram',
        'google',
        'google_display',
        'google_search',
        'google_universal_app',
        'naver',
        'kakao',
        'microsoft',
        'snapchat',
        'apple',
        'twitter',
        // 'tiktok',
        'amazon',
      ],
      ad: [
        'facebook',
        'instagram',
        'google',
        'google_display',
        'google_search',
        'google_universal_app',
        'naver',
        'kakao',
        'microsoft',
        'linkedin',
        'snapchat',
        // 'tiktok',
      ],
      keyword: ['google', 'google_search', 'naver', 'microsoft', 'apple', 'yahoo'],
    },
    neededKeys: [{ active: true }],
  },
  [actionTypes.budget]: {
    availableChannels: {
      campaign: [
        'facebook',
        'instagram',
        'google',
        'google_display',
        'google_search',
        'google_universal_app',
        'naver',
        'microsoft',
        'kakao',
        'linkedin',
        'yahoo',
        'apple',
      ],
      adSet: ['facebook', 'instagram', 'naver', 'kakao', 'snapchat'],
      ad: [],
    },
    neededKeys: [{ budget: { rawAmount: true } }],
  },
  [actionTypes.schedule_date]: {
    availableChannels: {
      campaign: ['google', 'google_display', 'google_search', 'google_universal_app', 'naver', 'linkedin', 'snapchat'],
      adSet: ['facebook', 'instagram', 'microsoft', 'kakao', 'snapchat', 'yahoo', 'apple'],
      ad: [],
    },
    neededKeys: [{ schedule: true }],
  },
  [actionTypes.schedule_time]: {
    availableChannels: {
      campaign: ['linkedin', 'snapchat'],
      adSet: ['facebook', 'snapchat', 'apple'],
      ad: [],
    },
    neededKeys: [{ schedule: true }],
  },
  [actionTypes.keyword_bid]: {
    availableChannels: {
      keyword: ['google', 'google_search', 'naver', 'apple', 'yahoo', 'microsoft'],
    },
    neededKeys: [],
  },
};

function isElementEditable({ element }) {
  const {
    cell: { subChannels = [] },
    channelAdAccountId,
    status,
    channel,
    isCustom,
  } = element;
  let isEditable = true;
  let disableReason = null;
  // no possible to edit internal elements
  if (
    !isCustom &&
    !['act_450144242759762', 'act_697499604468966', 'act_927103111409533'].includes(channelAdAccountId)
  ) {
    isEditable = false;
    disableReason = disableReasons.INTERNAL_ACCOUNT;
  }
  //no actions is possible for youtube
  if (subChannels.includes('google_video')) {
    isEditable = false;
    disableReason = disableReasons.CHANNEL_NOT_AVAILABLE;
  }
  if (NOT_AVAILIBLE_CHANNEL.includes(channel)) {
    isEditable = false;
    disableReason = disableReasons.CHANNEL_NOT_AVAILABLE;
  }
  // adAccount key not exist anymore
  // if (adAccount?.isBlocked) {
  //   isEditable = false
  //   disableReason = disableReasons.AD_ACCOUNT_BLOCKED
  // }
  if (status == 'DELETED') {
    isEditable = false;
    disableReason = disableReasons.ELEMENT_DELETED;
  }
  if (channel == 'externalFiles') {
    isEditable = false;
    disableReason = disableReasons.UPLOADED_FILES;
  }
  return {
    isEditable,
    disableReason,
  };
}

function isKeyExist(neededKeys, element) {
  let exists = false;
  for (const neededKey of neededKeys) {
    const [key] = Object.keys(neededKey);
    const subElement = element[key];
    if (typeof neededKey[key] == 'boolean' || (subElement == null && subElement == undefined)) {
      exists += Boolean(exists + (subElement != null && subElement != undefined));
    } else {
      exists += Boolean(exists + isKeyExist([neededKey[key]], subElement));
    }
  }
  return exists;
}

/*
 return :
 if some action are missing, it can be consider as not available
 [  {
     type : str, actionTypes,
     isAvailable : Bool,
     reason : opt, Str, disableReasons
   }
 ]
*/
function permittedActions({ architecture, elementId, item, level }) {
  if (level == 'adrielCampaign')
    return Object.values(actionTypes).map(action => ({
      type: action,
      isAvailable: false,
      reason: disableReasons.INTERNAL_ACCOUNT,
    }));

  const element = item || architecture.getElement({ elementId });
  const { channel, subChannels, isCustom } = element;

  const actions = [];
  const isEditable = isElementEditable({ element });
  if (!isEditable.isEditable)
    return Object.values(actionTypes).map(action => ({
      type: action,
      isAvailable: false,
      reason: isEditable.disableReason,
    }));

  for (const action of Object.values(actionTypes)) {
    const isActionAvaible = Boolean(
      possibleActions[action].availableChannels[level] &&
        possibleActions[action].availableChannels[level].includes(channel),
    );
    if (!isActionAvaible) {
      actions.push({
        type: action,
        isAvailable: false,
        reason: disableReasons.LVL_NOT_AVAILABLE,
      });
      continue;
    }
    const haveNeededKey =
      possibleActions[action].neededKeys && possibleActions[action].neededKeys.length
        ? isKeyExist(possibleActions[action].neededKeys, element)
        : true;
    if (!haveNeededKey) {
      actions.push({
        type: action,
        isAvailable: false,
        reason: disableReasons.NEEDED_VALUE_MISSING,
      });
      continue;
    }
    actions.push({
      type: action,
      isAvailable: true,
    });
  }
  return actions;
}

module.exports = {
  permittedActions,
  actionTypes,
  disableReasons,
};
